const Languages = [
  { code: 'pt', name: 'Português' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'it', name: 'Italiano' },
  { code: 'tr', name: 'Türk' },
  { code: 'ja', name: '日本人' },
  { code: 'ko', name: '한국의' },
  { code: 'zh', name: '簡中' },
  { code: 'zh_TW', name: '繁中', local: 'zht' },
  { code: 'th', name: 'ไทย' },
  { code: 'id', name: 'Indonesia' },
  { code: 'vi', name: 'Tiếng Việt' },
  { code: 'ru', name: 'Pусский' },
];

export default Languages;
